import React, { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';

import moment from 'moment';

import { motion } from 'framer-motion';
import styled from 'styled-components';

import { openMerch } from '@webapp/utils/merch/open-merch';

import { MerchProduct } from '@services/merch/types/api/merch-product';

import Typography from '@components/basics/typography';
import CircleRightArrowIcon from '@components/basics/icons/circle-right-arrow';

interface DraftMenuMerchItemProps {
  className?: string;
  product: MerchProduct;
}

const DraftMenuMerchItem: FunctionComponent<DraftMenuMerchItemProps> = ({
  className,
  product,
}) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    if (product.id) {
      dispatch(openMerch(product.id));
    }
  };
  return (
    <motion.div
      className={className || ''}
      onClick={handleClick}
      whileHover={{ scale: 1.0625 }}
      whileTap={{ scale: 1.125 }}
      transition={{
        duration: 0.6,
        ease: [0.0, 0.005, 0.2, 1.0],
      }}
    >
      <div className="draft-wrapper">
        <Image
          className="draft-cover"
          src={
            product.sizes[0]?.images?.find((img) => img.position === 'front')
              ?.src
          }
          alt={product.title}
        />
        <div className="draft-info">
          <Typography weight="700">{product.title}</Typography>
          <Typography type="small" opacity="0.5">
            {moment(product.createdAt).format('DD MMM YYYY')}
          </Typography>
        </div>
      </div>
      <CircleRightArrowIcon darkerCircleColor />
    </motion.div>
  );
};

export default styled(DraftMenuMerchItem)`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${({ theme }) => theme.device.tablet} {
    margin-right: 74px;
  }

  .draft-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    .draft-cover {
      margin-right: 14px;
      flex-shrink: 0;
    }
  }
`;

const Image = styled(motion.img)`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.circleBgIcon};
`;
